import React, { useState, Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { ButtonToolbar, Button, Label } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import DateField from '../../../shared/components/form/DateField';
import select from '../../../shared/components/form/Select';
import CheckBox from '../../../shared/components/form/CheckBox';
import { FILTER_BY } from '../../../shared/utils/constants';
import DateFilterType from './DateFilterType';
import { FieldProps } from '../../../shared/prop-types/FieldProps';

const Filter = (props) => {
  const {
    t,
    customers,
    categories,
    contracts,
    filterClick,
    initialize,
    lastFilter,
    type,
    accounts,
  } = props;

  const [filter, setFilter] = useState({
    initialDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
      0,
      0,
      0,
      0
    ),
    finalDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0,
      0,
      0,
      0
    ),
    filterByDate: true,
    opened: true,
    canceled: true,
    partiallyDownloaded: true,
    downloaded: true,
    contract: '',
    type,
    categoryId: 0,
    clientId: 0,
    dateFilterType: FILTER_BY.DUE_DATE,
  });

  const filterCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      setFilter(updatedFilter);
    }
  };

  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    if (value) {
      updatedFilter[field] = value;
    } else {
      updatedFilter[field] = 0;
    }
    setFilter(updatedFilter);
  };

  useEffect(() => {
    if (lastFilter) {
      setFilter(lastFilter);
      initialize(lastFilter);
    } else {
      initialize(filter);
    }
  }, []);

  return (
    <MuiThemeProvider>
      <Fragment>
        <div className="form">
          <div className="form__form-group">
            <div className="form__form-group-field">
              <DateFilterType
                dateFilterType={filter.dateFilterType}
                onChangeFilter={(value) =>
                  filterChange('dateFilterType', value)
                }
              />
            </div>
          </div>
          <div className="form__form-group--2_columns">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.initial_date')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="initialDate"
                  component={DateField}
                  value={filter.initialDate}
                  onChange={(value) => filterChange('initialDate', value)}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.final_date')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="finalDate"
                  component={DateField}
                  value={filter.finalDate}
                  minDate={filter.initialDate}
                  onChange={(value) => filterChange('finalDate', value)}
                />
              </div>
            </div>
          </div>
          <div className="form__form-group--4_columns">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.contract')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="contract"
                  type="text"
                  component={select}
                  options={contracts}
                  placeholder={t('general.placeholders.select')}
                  onChange={(values) => filterChange('contract', values)}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.client')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="clientId"
                  type="text"
                  closeMenuOnSelect
                  component={select}
                  options={customers}
                  placeholder={t('general.placeholders.select')}
                  onChange={(values) => filterChange('clientId', values)}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.category')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="categoryId"
                  type="text"
                  closeMenuOnSelect
                  component={select}
                  options={categories}
                  placeholder={t('general.placeholders.select')}
                  onChange={(values) => filterChange('categoryId', values)}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.account')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="accountId"
                  component={select}
                  options={accounts}
                  placeholder={t('general.placeholders.select')}
                  onChange={(values) => filterChange('accountId', values)}
                />
              </div>
            </div>
          </div>
          <div className="form__form-group--4_columns">
            <div className="form__form-group-field">
              <Label className="form__form-group-label pr-2">
                {t('general.A')}
              </Label>
              <Field
                name="opened"
                component={CheckBox}
                className="colored-click "
                onChange={(evt) => filterCheckChange(evt)}
              />
            </div>
            <div className="form__form-group-field">
              <Label className="form__form-group-label pr-2">
                {t('general.C')}
              </Label>
              <Field
                name="canceled"
                component={CheckBox}
                className="colored-click"
                onChange={(evt) => filterCheckChange(evt)}
              />
            </div>
            <div className="form__form-group-field">
              <Label className="form__form-group-label pr-2">
                {t('general.P')}
              </Label>
              <Field
                name="partiallyDownloaded"
                component={CheckBox}
                className="colored-click"
                onChange={(evt) => filterCheckChange(evt)}
              />
            </div>
            <div className="form__form-group-field">
              <Label className="form__form-group-label pr-2">
                {t('general.B')}
              </Label>
              <Field
                name="downloaded"
                component={CheckBox}
                className="colored-click"
                onChange={(evt) => filterCheckChange(evt)}
              />
            </div>
          </div>
        </div>
        <ButtonToolbar className="filter-button">
          <Button color="success" onClick={() => filterClick(filter)}>
            {t('general.filter')}
          </Button>
        </ButtonToolbar>
      </Fragment>
    </MuiThemeProvider>
  );
};

Filter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  contracts: PropTypes.arrayOf(FieldProps).isRequired,
  customers: PropTypes.arrayOf(FieldProps).isRequired,
  categories: PropTypes.arrayOf(FieldProps).isRequired,
  accounts: PropTypes.arrayOf(FieldProps).isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
  type: PropTypes.string.isRequired,
};

Filter.defaultProps = {
  lastFilter: null,
};

export default reduxForm({
  form: 'AccountsFilter',
})(withTranslation('common')(Filter));
